import { axiosInstance } from "../../utils";
import { useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../queryKeys";
//import { AxiosError } from "axios/index";

export function useCandidateDelete() {
    const axios = axiosInstance();
    const queryClient = useQueryClient();
    const toast = useToast();

    return useMutation({
        mutationFn: async (requests: { clientId: string; entityId: string; candidateId: string }[]) => {
            for (const request of requests) {
                await axios.delete(`api/clients/${request.clientId}/entities/${request.entityId}/candidates/${request.candidateId}/DeleteEntityCandidate`);
            }
        },
        onSuccess: async () => {
            toast({
                title: "Successful Deletion",
                description: "Deletion successful",
                status: "success",
                isClosable: true,
                duration: 2000,
            });

            await queryClient.invalidateQueries(queryKeys.candidates.byEntity._def);
        },
        onError: error => {
            // NOTE: this was before task 32822: const axiosError = error as AxiosError;
            toast({
                title: "Deletion Error",
                // description: `[${axiosError.request.status ?? "ERR"}]: ${axiosError.message}`,
                description: "There was an error deleting the candidate(s). Please try again.",
                status: "error",
                isClosable: true,
                duration: 2000,
            });

            queryClient.invalidateQueries(queryKeys.candidates.byEntity._def);
        },
    });
}
